// Women's Healthcare data for desktop content
export const hospitalData = {
  header: {
    title: "MR Gamb Medya",
    subtitle: "Medya Alanında Güçlü Ağınız",
    logo: "https://assets.mrgambcommunity.com/mrgambmedia/mrgambmedia.ico",
    navItems: [
      { title: "Ana Sayfa", link: "/" },
      { title: "Hakkımızda", link: "https://mr-run.com  " },
      { title: "Randevu Al", link: "https://t.me/areftherat" },
    ]
  },
  hero: {
    title: "MR Gamb Medya",
    subtitle: "Medya Alanında Güçlü Ağınız",
    buttons: [
      { text: "Telegram", color: "purple", link: "https://t.me/mrgambofficial" },
      { text: "Microsoft Teams", color: "orange", link: "https://teams.microsoft.com/l/team/19%3A19%40thread.tacv2/members?tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47" },
      { text: "MR Gamb", color: "purple", link: "https://mr-run.com" }
    ]
  },
  services: [
    {
      id: 1,
      title: "MrGamb Media ile Dijital Gücünü Artır",
      content: "MrGamb Media, markaların dijital dünyada daha görünür olmasını sağlayan yenilikçi medya çözümleri sunar. İster küçük bir girişim olun ister global ölçekte faaliyet gösterin, mrgamb medya ekibimiz size özel SEO, reklam yönetimi ve içerik stratejileri hazırlar. Böylece arama motorlarında ilk sıralarda yer alabilir, daha fazla kullanıcıya ulaşabilirsiniz. MrGamb ile sadece trafik değil, gerçek dönüşüm odaklı sonuçlar elde edersiniz.",
      icon: "📈",
      color: "purple"
    },
    {
      id: 2,
      title: "Mrgamb Medya ile Marka Bilinirliğini Yükselt",
      content: "Mrgamb medya, sosyal medya yönetiminden içerik üretimine kadar geniş kapsamlı dijital pazarlama desteği verir. Ekip, marka kimliğinizi doğru hedef kitleye ulaştırmak için özel çözümler geliştirir. MrGamb Media sayesinde markanız online dünyada güçlü bir imaj kazanır. SEO uyumlu içerikler, profesyonel görsel tasarımlar ve etkili reklam kampanyaları ile büyüme sürecinizi hızlandırabilirsiniz.",
      icon: "🌐",
      color: "purple"
    }
  ],
  doctor: {
    name: "MrGamb Medya",
    title: "Dijital Güçlü Ağınız",
    bio: "MrGamb Medya, markaların dijital dünyada daha görünür olmasını sağlayan yenilikçi medya çözümleri sunar. İster küçük bir girişim olun ister global ölçekte faaliyet gösterin, mrgamb medya ekibimiz size özel SEO, reklam yönetimi ve içerik stratejileri hazırlar. Böylece arama motorlarında ilk sıralarda yer alabilir, daha fazla kullanıcıya ulaşabilirsiniz. MrGamb ile sadece trafik değil, gerçek dönüşüm odaklı sonuçlar elde edersiniz.",
    image: "https://assets.mrgambcommunity.com/CaseGamb.png",
    rating: 3.0,
    yelpRating: "3.0 (72 reviews)",
    reviewHighlights: [
      {
        platform: "MRGamb",
        author: "Ay***",
        text: "Mr Gamb ekibi sayesinde sitem kısa sürede yükseldi. mrgamb medya SEO paketleri şeffaf ve sonuç odaklı, mrgemb ile reklam optimizasyonu da gözle görülür fark yarattı.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Me***",
        text: "mrgamp içerik stratejileri ile organik trafik kalıcı hale geldi. MrGamb Media raporları net, iletişim hızlı. Her ay istikrarlı büyüme görüyorum.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Se***",
        text: "Sosyal medya yönetiminde mrgemp yaklaşımı harika. MrGamb kampanyaları ile etkileşim ve dönüşüm aynı anda arttı. Tavsiye ederim.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Bu***",
        text: "MrGamb medya ekibi web sitesi optimizasyonunda teknik hataları hızlıca çözdü. mrgamb anahtar kelimelerinde ilk sayfaya çıktık.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Ka***",
        text: "mrgemb içerik planı ve backlink stratejisiyle satışlarımız arttı. MrGamb Media sürekli A/B testi yaparak bütçeyi verimli kullandı.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "El***",
        text: "Görsel tasarım ve sayfa hızında büyük iyileşme oldu. Mr Gamb SEO teknikleri sayesinde core web vitals değerlerimiz yeşile döndü.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Ha***",
        text: "mrgamp reklam yönetimi ile tıklama başı maliyet düştü, dönüşüm oranı yükseldi. MrGamb raporları anlaşılır ve aksiyon odaklı.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Ni***",
        text: "MrGamb Media ile kurumsal blog stratejisi kurduk. mrgemp uzun kuyruklu kelimelerde hızlıca sıralama aldık. Süreç çok profesyoneldi.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Öz***",
        text: "mrgamb teknik SEO denetimi sonrasında site haritaları ve schema düzenlendi. MrGamb sayesinde organik görünürlük belirgin arttı.",
        rating: 5
      }
    ]
  },
  medicalServices: [
    { name: "SEO", icon: "🚀" },
    { name: "Reklam Yönetimi", icon: "📢" },
    { name: "İçerik Stratejileri", icon: "📝" },
    { name: "Sosyal Medya Yönetimi", icon: "📱" },
    { name: "Görsel Tasarım", icon: "🎨" },
    { name: "Web Sitesi Tasarımı", icon: "💻" },
    { name: "Web Sitesi Geliştirme", icon: "⚙️" },
    { name: "Web Sitesi Optimizasyonu", icon: "⚡" },
    { name: "Web Sitesi Analizi", icon: "📊" }
  ],
  awards: [
    {
      title: "MRGAMB® MEDIA OF EXCELLENCE",
      subtitle: "DIGITAL MARKETING & SEO",
      type: "gold",
      description: "MR Gamb Medya, dijital pazarlama ve SEO alanında uluslararası standartlara uygun şekilde 'Center of Digital Excellence' sertifikasına layık görülmüştür. Bu başarı, mrgamb media ekibinin yenilikçi stratejiler, sürdürülebilir büyüme ve müşteri memnuniyeti odaklı yaklaşımını simgelemektedir.\n\n\"MRGamb Media ile markalar yalnızca görünürlük kazanmaz, aynı zamanda uzun vadeli dijital başarıya ulaşır. Bu sertifika, sektörün en iyi medya kuruluşlarından biri olduğumuzu resmi olarak belgeliyor.\" - <a href=\"https://mr-run.com\" target=\"_blank\" rel=\"noopener noreferrer\">MRGAMB </a>"
    },
    {
      title: "MRGAMB® MASTER AGENCY",
      subtitle: "DIGITAL STRATEGY & BRANDING",
      type: "gold",
      description: "2025 yılında MR Gamb Media, 'Master Agency of Digital Excellence' akreditasyonunu alarak SEO, içerik üretimi ve reklam yönetimi alanlarında liderliğini tescillemiştir. Bu ödül, mrgamb medya ekibinin profesyonel kadrosunun dijital dünyada en yüksek kalite standartlarını karşılayan çözümler sunduğunu göstermektedir.\n\nBu akreditasyon, MrGamb Media’nın hem ulusal hem uluslararası markalara güvenilir bir partner olduğunu kanıtlıyor. Daha fazla bilgi için: <a href=\"https://mr-run.com\" target=\"_blank\" rel=\"noopener noreferrer\">MR Gamb</a>"
    }    
  ],
  insurance: {
    description: "MrGamb Media olarak iş ortaklarımızın güvenini ön planda tutuyoruz. Birçok farklı sağlayıcıdan gelen sigorta planlarını kabul ediyoruz ve mrgamb medya üzerinden sunduğumuz hizmetler, geniş kapsama alanıyla desteklenmektedir. Eğer listede sigorta sağlayıcınızı görmüyorsanız, bize ulaşarak detaylı bilgi alabilirsiniz. MrGamb ekibi, her zaman kullanıcılarına güvenli, şeffaf ve sürdürülebilir çözümler sunmayı hedefler.",
    images: [
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/2206449.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1773061.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1771881.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1771850.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1775714.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/2272134.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/2614660.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1778044.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1771770.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1771701.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1790683.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1771704.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1771876.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1798608.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1785544.png",
      "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1771716.png"
    ],
    viewMoreLink: "https://mr-run.com"
  },
  testimonials: [
    {
      platform: "MRGamb",
      author: "Ay***",
      text: "Mr Gamb ekibi sayesinde sitem kısa sürede yükseldi. mrgamb medya SEO paketleri şeffaf ve sonuç odaklı, mrgemb ile reklam optimizasyonu da gözle görülür fark yarattı.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Me***",
      text: "mrgamp içerik stratejileri ile organik trafik kalıcı hale geldi. MrGamb Media raporları net, iletişim hızlı. Her ay istikrarlı büyüme görüyorum.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Se***",
      text: "Sosyal medya yönetiminde mrgemp yaklaşımı harika. MrGamb kampanyaları ile etkileşim ve dönüşüm aynı anda arttı. Tavsiye ederim.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Bu***",
      text: "MrGamb medya ekibi web sitesi optimizasyonunda teknik hataları hızlıca çözdü. mrgamb anahtar kelimelerinde ilk sayfaya çıktık.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Ka***",
      text: "mrgemb içerik planı ve backlink stratejisiyle satışlarımız arttı. MrGamb Media sürekli A/B testi yaparak bütçeyi verimli kullandı.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "El***",
      text: "Görsel tasarım ve sayfa hızında büyük iyileşme oldu. Mr Gamb SEO teknikleri sayesinde core web vitals değerlerimiz yeşile döndü.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Ha***",
      text: "mrgamp reklam yönetimi ile tıklama başı maliyet düştü, dönüşüm oranı yükseldi. MrGamb raporları anlaşılır ve aksiyon odaklı.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Ni***",
      text: "MrGamb Media ile kurumsal blog stratejisi kurduk. mrgemp uzun kuyruklu kelimelerde hızlıca sıralama aldık. Süreç çok profesyoneldi.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Öz***",
      text: "mrgamb teknik SEO denetimi sonrasında site haritaları ve schema düzenlendi. MrGamb sayesinde organik görünürlük belirgin arttı.",
      rating: 5
    }
  ],  
  contact: {
    location: "301 W Surf St, Chicago, IL 60657",
    hours: "7/24",
    parking: "Indoor Parking Available at Our 301 W Surf St. Office"
  }
};
